import App from "./App";
import designs from "./designs";

export function designFromPath(pathname) {
  const match = pathname.match(/^\/([1-5])\/?$/);
  return match ? Number(match[1]) : null;
}

export default function Root() {
  const number = designFromPath(window.location.pathname);
  const Design = number ? designs[number] : null;
  return Design ? <Design /> : <App />;
}
